import _defineProperty from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/tenten/Projects/upcos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { testAudioBufferCopyChannelMethodsOutOfBoundsSupport } from '../helpers/test-audio-buffer-copy-channel-methods-out-of-bounds-support';
import { wrapAudioBufferGetChannelDataMethod } from '../helpers/wrap-audio-buffer-get-channel-data-method';
var DEFAULT_OPTIONS = {
  numberOfChannels: 1
};
export var createAudioBufferConstructor = function createAudioBufferConstructor(audioBufferStore, cacheTestResult, createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, testNativeAudioBufferConstructorSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds) {
  var nativeOfflineAudioContext = null;
  return /*#__PURE__*/function (_Symbol$hasInstance) {
    function AudioBuffer(options) {
      _classCallCheck(this, AudioBuffer);
      if (nativeOfflineAudioContextConstructor === null) {
        throw new Error('Missing the native OfflineAudioContext constructor.');
      }
      var _DEFAULT_OPTIONS$opti = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options),
        length = _DEFAULT_OPTIONS$opti.length,
        numberOfChannels = _DEFAULT_OPTIONS$opti.numberOfChannels,
        sampleRate = _DEFAULT_OPTIONS$opti.sampleRate;
      if (nativeOfflineAudioContext === null) {
        nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
      }
      /*
       * Bug #99: Firefox does not throw a NotSupportedError when the numberOfChannels is zero. But it only does it when using the
       * factory function. But since Firefox also supports the constructor everything should be fine.
       */
      var audioBuffer = nativeAudioBufferConstructor !== null && cacheTestResult(testNativeAudioBufferConstructorSupport, testNativeAudioBufferConstructorSupport) ? new nativeAudioBufferConstructor({
        length: length,
        numberOfChannels: numberOfChannels,
        sampleRate: sampleRate
      }) : nativeOfflineAudioContext.createBuffer(numberOfChannels, length, sampleRate);
      // Bug #99: Safari does not throw an error when the numberOfChannels is zero.
      if (audioBuffer.numberOfChannels === 0) {
        throw createNotSupportedError();
      }
      // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
      // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
      if (typeof audioBuffer.copyFromChannel !== 'function') {
        wrapAudioBufferCopyChannelMethods(audioBuffer);
        wrapAudioBufferGetChannelDataMethod(audioBuffer);
        // Bug #157: Only Chrome & Opera do allow the bufferOffset to be out-of-bounds.
      } else if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, function () {
        return testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer);
      })) {
        wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
      }
      audioBufferStore.add(audioBuffer);
      /*
       * This does violate all good pratices but it is necessary to allow this AudioBuffer to be used with native
       * (Offline)AudioContexts.
       */
      return audioBuffer;
    }
    _createClass(AudioBuffer, null, [{
      key: _Symbol$hasInstance,
      value: function value(instance) {
        return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === AudioBuffer.prototype || audioBufferStore.has(instance);
      }
    }]);
    return AudioBuffer;
  }(Symbol.hasInstance);
};